import { Button, HighlightAltIcon, ModeEditTwoToneIcon } from 'tuui';
import { INDICATION_TYPES, IndicationContent } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './valueSelector.module.scss';

export const ValueSelector = ({ selectedValue, onSelect, onEdit }) => {
    if (!selectedValue) {
        return (
            <div className={styles['container']}>
                <div>
                    <IndicationContent
                        type={INDICATION_TYPES.INFO}
                        containerClassName={styles['container-info-indication']}
                    >
                        <FormattedMessage
                            id="codeless.setup.value.info"
                            defaultMessage="Click on 'Select Value' button to continue"
                        />
                    </IndicationContent>
                </div>
                <Button
                    variant={Button.variant.primary}
                    size={Button.size.md}
                    className={styles['select-button']}
                    onClick={onSelect}
                >
                    <HighlightAltIcon />
                    <FormattedMessage id="codeless.setup.value.select_button" defaultMessage="Select Value" />
                </Button>
            </div>
        );
    }

    return (
        <div className={styles['selected-value-container']}>
            <IndicationContent
                containerClassName={styles['container-success-indication']}
                type={INDICATION_TYPES.SUCCESS}
            >
                <div className={styles['indication-content']}>
                    <FormattedMessage
                        id="codeless.setup.value.selected"
                        defaultMessage="{value} was selected"
                        values={{ value: selectedValue }}
                    />
                    <Button
                        variant={Button.variant.primary}
                        size={Button.size.md}
                        className={styles['edit-button']}
                        onClick={onEdit}
                    >
                        <ModeEditTwoToneIcon />
                    </Button>
                </div>
            </IndicationContent>
        </div>
    );
};
